import bloom from '../assets/zencera-bloom.svg';

// The in-app lockup: the bloom (cropped from the full logo SVG, never
// redrawn) beside the live-text "zencera" wordmark in `brand-plum`.
export function Lockup({ className = '' }: { className?: string }) {
  return (
    <span className={`zc-lockup ${className}`}>
      <span className="mark">
        <img src={bloom} alt="" />
      </span>
      <span className="word">zencera</span>
    </span>
  );
}
